import React, { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LanguageContext } from "../LanguageContext";
import "../styles/Loading.css";
import backgroundImage from "../assets/home_background.png";

const Loading = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useContext(LanguageContext);
  const score = location.state?.score || 0;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const timer = setTimeout(() => {
      navigate("/result", { state: { score } });
    }, 2000);
    return () => {
      document.body.style.overflow = "";
      clearTimeout(timer);
    };
  }, [navigate, score]);

  return (
    <div
      className="loading-container"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="loading-overlay">
        <div className="loading-content">
          <h2>
            {language === "ko"
              ? "당신의 임신 가능률은..."
              : "Your estimated pregnancy probability is..."}
          </h2>
          <p>
            {language === "ko"
              ? "결과를 분석하고 있습니다..."
              : "Analyzing your result..."}
          </p>
          <div className="loading-spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
